import { useState } from "react";
import PageLayout, { Section } from "./PageLayout";
import { toast } from "sonner";

export default function Cookies() {
  const [prefs, setPrefs] = useState({
    essential: true,
    analytics: localStorage.getItem("djino_cookies_analytics") !== "off",
    marketing: localStorage.getItem("djino_cookies_marketing") === "on",
  });

  const save = () => {
    localStorage.setItem("djino_cookies_analytics", prefs.analytics ? "on" : "off");
    localStorage.setItem("djino_cookies_marketing", prefs.marketing ? "on" : "off");
    toast.success("Cookie preferences saved");
  };

  return (
    <PageLayout
      eyebrow="Legal"
      title="Cookie Policy"
      subtitle="Last updated: February 8, 2026"
    >
      <Section title="1. What are cookies?">
        <p>Cookies are small text files stored on your device when you visit a website. They help us remember your preferences, keep you signed in, and understand how the Service is used.</p>
      </Section>

      <Section title="2. Types we use">
        <div className="space-y-3">
          <div className="bg-[#0d0d0d] border border-white/5 rounded-xl p-5">
            <div className="font-bold mb-1" style={{ fontFamily: "Outfit" }}>Essential <span className="text-xs font-normal text-[#888] ml-2">(always on)</span></div>
            <p className="text-sm text-[#bbb]">Required for the Service to work — session token, profile selection, language. Cannot be disabled.</p>
          </div>
          <div className="bg-[#0d0d0d] border border-white/5 rounded-xl p-5">
            <div className="font-bold mb-1" style={{ fontFamily: "Outfit" }}>Analytics</div>
            <p className="text-sm text-[#bbb]">Anonymous usage data so we can improve the product (popular titles, slow pages, crash reports).</p>
          </div>
          <div className="bg-[#0d0d0d] border border-white/5 rounded-xl p-5">
            <div className="font-bold mb-1" style={{ fontFamily: "Outfit" }}>Marketing</div>
            <p className="text-sm text-[#bbb]">Personalize ads and measure their performance. You can opt out anytime.</p>
          </div>
        </div>
      </Section>

      <Section title="3. Manage your preferences">
        <div className="bg-[#0d0d0d] border border-white/5 rounded-2xl p-6 space-y-4" data-testid="cookie-preferences">
          {[
            { key: "essential", label: "Essential cookies", locked: true },
            { key: "analytics", label: "Analytics cookies" },
            { key: "marketing", label: "Marketing cookies" },
          ].map((c) => (
            <div key={c.key} className="flex items-center justify-between border-b border-white/5 last:border-0 pb-4 last:pb-0">
              <div>
                <div className="font-semibold">{c.label}</div>
                <div className="text-xs text-[#888]">{c.locked ? "Required for the Service" : "Optional"}</div>
              </div>
              <button
                onClick={() => !c.locked && setPrefs({ ...prefs, [c.key]: !prefs[c.key] })}
                disabled={c.locked}
                data-testid={`toggle-${c.key}`}
                className={`relative w-12 h-6 rounded-full transition ${prefs[c.key] ? "bg-[#E50914]" : "bg-white/15"} ${c.locked ? "opacity-60 cursor-not-allowed" : ""}`}
              >
                <span className={`absolute top-0.5 ${prefs[c.key] ? "left-6" : "left-0.5"} w-5 h-5 rounded-full bg-white transition-all`} />
              </button>
            </div>
          ))}
          <button onClick={save} className="btn-primary mt-2" data-testid="save-cookies-btn">Save preferences</button>
        </div>
      </Section>

      <Section title="4. Third-party cookies">
        <p>We use a small number of third-party services that may set their own cookies — PayPal (payments), Resend (email tracking pixel for delivery confirmation only). These providers operate under their own privacy policies.</p>
      </Section>

      <Section title="5. Browser controls">
        <p>You can also block or delete cookies directly in your browser settings. Note that disabling essential cookies may break sign-in and playback.</p>
      </Section>

      <Section title="6. Contact">
        <p>Questions about cookies? <a className="text-[#E50914]" href="mailto:privacy@djinostream.com">privacy@djinostream.com</a>.</p>
      </Section>
    </PageLayout>
  );
}
